var _g, _line, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLastPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_15047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0315 17L16.0684 12L11.0315 7V17Z",
    fill: "#323232"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.259,
    y1: 7,
    x2: 18.259,
    y2: 17,
    stroke: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_15047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1773,
    height: 24,
    fill: "white",
    transform: "translate(0.95752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPage);
export default __webpack_public_path__ + "static/media/last_page.5ee6ed8f033f4389db1f397e234bbca5.svg";
export { ForwardRef as ReactComponent };